var map = {
	"./Dry Ice Boxes.png": 2740,
	"./Insulated Box.png": 7167,
	"./Insulation Boxes.png": 4639,
	"./Vaccine Boxes.png": 9476,
	"./services": 6928,
	"./services.json": 6928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;